export function registerTemplateHelpers(context) {
  context.registerTemplateHelper('or', or);
  context.registerTemplateHelper('equals', equals);
  context.registerTemplateHelper('greaterThan', greaterThan);
  context.registerTemplateHelper('lessThan', lessThan);
  context.registerTemplateHelper('domId', domId);
  context.registerTemplateHelper('inspect', inspect);
  context.registerTemplateHelper('setContext', setContext);
}

function domId(object, prefix) {
  return prefix + '_' + (object?.id || object);
}

function or(...args) {
  const maybeOptions = args[args.length - 1];
  const isOptions = maybeOptions && (typeof maybeOptions.fn === 'function' || typeof maybeOptions.inverse === 'function');
  if (isOptions) args.pop();
  const result = args.some(Boolean);
  return isOptions ? (result ? maybeOptions.fn(this) : maybeOptions.inverse(this)) : result;
}

function equals(a, b, options) {
  // Dual-mode: block helper (with options.fn) or subexpression (returns boolean)
  if (options && typeof options.fn === 'function') {
    return a === b ? options.fn(this) : options.inverse(this);
  }
  return a === b;
}

function greaterThan(a, b, options) {
  if (options && typeof options.fn === 'function') {
    return a > b ? options.fn(this) : options.inverse(this);
  }
  return a > b;
}

function lessThan(a, b, options) {
  if (options && typeof options.fn === 'function') {
    return a < b ? options.fn(this) : options.inverse(this);
  }
  return a < b;
}

function inspect(object) {
  return JSON.stringify(object, null, 2);
}

function setContext(context, options) {
  return options.fn(context);
}